import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetProfile = () => {
  const profileService = useServices().profileService;
  return useQuery({
    queryKey: ['profileData'],
    queryFn: async () => {
      const response = await profileService.getProfile();
      localStorage.culture = response.culture;
      return response;
    },
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
};
